export const ADD_IMAGES = 'ADD_IMAGES';
export const DELETE_IMAGES = 'DELETE_IMAGES';
